import React, { useState, useEffect } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

import { Card, Col, Form, Row, Table } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';
import SalesBySellerChart from './comparativo-ventas/SalesBySellerChart';

const SalesBySeller = () => {
    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();

    const [data, setData] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState('current');
    const [cargandoData, setCargandoData] = useState(false);

    useEffect(() => {
        obtenerVentasPorVendedor();
    }, [selectedPeriod]);


    /**
     * Obtiene las ventas anuales por vendedor
     */
    const obtenerVentasPorVendedor = async () => {
        setCargandoData(true);

        const body = {
            fechaInicio: getFechaInicio(selectedPeriod),
            fechaFin: getFechaFin(selectedPeriod)
        };
        try {
            const response = await fetch('/api/Administradores/obtenerVentasPorVendedor', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            if (response?.ok) {
                const responseType = await response.json();

                if (responseType.iResponseType === 1) {
                    const parsed = JSON.parse(responseType.detalles);
                    const dataArray = parsed.table2;

                    // Filtrar solo vendedores con ventas
                    const vendedoresConVentas = dataArray.filter(v => v.totalMXN > 0);

                    const totalGlobal = vendedoresConVentas.reduce(
                        (sum, item) => sum + parseFloat(item.totalMXN),
                        0
                    );

                    const dataMapped = vendedoresConVentas.map((item, i) => {
                        const porcentaje = (parseFloat(item.totalMXN) / totalGlobal) * 100;

                        return {
                            label: item.vUsuario,
                            value: porcentaje.toFixed(1),
                            percentage: porcentaje.toFixed(1) + '%',
                            color: ['primary', 'success', 'info', 'warning', 'danger', 'secondary'][i % 6],
                            totalMXN: parseFloat(item.totalMXN).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
                        };
                    });

                    setData(dataMapped);
                } else {
                    showErrorToast(responseType.vMessage);
                }
            } else {
                showErrorToast(response?.status + ' ' + response?.statusText);

                if (response?.status === 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            showErrorToast('Hubo un problema con la petición Fetch: ' + error.message);
            console.error('❌ Error en obtenerVentasPorVendedor:', error);
        }

        setCargandoData(false);
    };



    function getFechaInicio(period) {
        const year = new Date().getFullYear();
        if (period === 'current') return `${year}-01-01`;
        if (period === 'last') return `${year - 1}-01-01`;
        return `${parseInt(period)}-01-01`;
    }

    function getFechaFin(period) {
        const year = new Date().getFullYear();
        if (period === 'current') return new Date().toISOString().split('T')[0];
        if (period === 'last') return `${year - 1}-12-31`;
        return `${parseInt(period)}-12-31`;
    }

    const handlePeriodChange = (period) => {
        setSelectedPeriod(period);
    };

    return (
        <Card className="h-100">
            <FalconCardHeader
                title="Ventas por vendedor"
                titleTag="h6"
                className="py-2"
                light
            />
            <Card.Body as={Flex} direction="column" justifyContent="between" className="py-0">
                <div className="my-auto py-5 py-md-5">
                    {cargandoData ? (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Cargando...</span>
                            </div>
                        </div>
                    ) : (
                        <SalesBySellerChart data={data} />
                    )}
                </div>
                <div className="border-top">
                    <Table size="sm" className="mb-0">
                        <tbody>
                            {cargandoData ? (
                                <tr>
                                    <td colSpan="2" className="text-center py-3">
                                        <div className="spinner-border spinner-border-sm text-primary" role="status">
                                            <span className="visually-hidden">Cargando...</span>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                data.map((item) => (
                                    <tr key={item.label}>
                                        <td className="py-2">
                                            <span className="text-900 fw-medium">{item.label}</span>
                                        </td>
                                        <td className="py-2 text-center">
                                            <span className="text-900 fw-medium">{item.totalMXN}</span>
                                        </td>
                                        <td className="py-2 text-end">
                                            <span className="text-900 fw-bold">{item.percentage}</span>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </div>
            </Card.Body>
            <Card.Footer className="bg-light py-2">
                <Row className="g-0 flex-between-center">
                    <Col xs="auto" className="d-flex gap-2">
                        <Form.Select
                            size="sm"
                            value={selectedPeriod}
                            disabled={cargandoData}
                            onChange={(e) => handlePeriodChange(e.target.value)}
                        >
                            <option value="current">AÑO ACTUAL</option>
                            <option value="last">AÑO PASADO</option>
                            <option value="2023">2023</option>
                            <option value="2022">2022</option>
                            <option value="2021">2021</option>
                            <option value="2020">2020</option>
                        </Form.Select>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    );
};

export default SalesBySeller;
